import PropTypes from 'prop-types';
import { TimePicker } from 'antd';
import dayjs from 'dayjs';
import { TIME_FORMAT } from 'const';
import Styles from './TimePicker.module.css';
import { useMemo } from 'react';

const TimePickerMain = ({ value, onChange, ...props }) => {
  const dayjsValue = useMemo(() => {
    if (!value) return null;

    try {
      if (typeof value === 'string') {
        const d = dayjs(value);
        return d.isValid() ? d : null;
      }

      if (value instanceof Date) {
        return dayjs(value);
      }

      if (dayjs.isDayjs(value)) {
        return value;
      }

      return null;
    } catch (error) {
      console.error('Error parsing time value:', error);
      return null;
    }
  }, [value]);

  const defaultOpenDayjs = useMemo(() => dayjs('00:00', TIME_FORMAT), []);

  const handleChange = (time) => {
    if (onChange) {
      if (dayjs.isDayjs(time) && time.isValid()) {
        onChange(time.toISOString());
      } else {
        onChange(null);
      }
    }
  };

  return (
    <TimePicker
      defaultOpenValue={defaultOpenDayjs}
      className={Styles.timePicker}
      value={dayjsValue}
      format={TIME_FORMAT}
      {...props}
      onChange={handleChange}
    />
  );
};

TimePickerMain.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
    PropTypes.object,
  ]),
};

export { TimePickerMain as TimePicker };
